import axios from 'axios';

export class CustodyTitlesService {

    getFilters() {
        return axios.get('/custodia/instruction/filters', {
            headers: {
                'Content-Type': 'application/json',
            },
            params: {}
        }).then(res => res.data);
    }

    geInstruction(loanId, ptmObj, pttObj, statusObj, eventTypeObj) {
        return axios.get('/custodia/instructions/', {
            headers: {
                'Content-Type': 'application/json',
            },
            params: {
                loanId: loanId ? loanId : 0,
                ptmObj: ptmObj.lenderId ? ptmObj.lenderId : 0,
                pttObj: pttObj.borrowerId ? pttObj.borrowerId : 0,
                status: statusObj.statusName ? statusObj.statusName : "",
                eventType: eventTypeObj.instructionId ? eventTypeObj.instructionId : "",
            }
        }).then(res => res.data);
    }

    settleInstruction(loanId) {
        return axios.post('/custodia/instruction/settle/' + loanId + "/by/" + localStorage.getItem('username'), {}, {
            params: {}
        }).then(res => res.data);

    }

    confirmSettleInstruction(loanId) {
        return axios.post('/custodia/instruction/confirmSettle/' + loanId + "/by/" + localStorage.getItem('username'), {}, {
            params: {}
        }).then(res => res.data);

    }

    cancelInstruction(loanId) {
        return axios.post('/custodia/instruction/cancel/' + loanId + "/by/" + localStorage.getItem('username'), {}, {
            params: {}
        }).then(res => res.data);

    }

    getCSV() {
        return axios({
            url: '/custodia/instructions/csv-format',
            method: 'GET',
            responseType: 'blob',
            params: {}
        }).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'CustodioTitulos.xls');
            document.body.appendChild(link);
            link.click();
        })
    }

    getAutomaticLender() {
        return axios.get('/custodia/automaticLender/', {
            headers: {
                'Content-Type': 'application/json',
            }
        }).then(res =>
            res.data.payload);
    }

    updateAutomatic(instList) {
        return axios.put('/custodia/automaticLender/setAutomatic/', instList,{
            headers: {
                'Content-Type': 'application/json',
            }
        }).then(res =>
            res.data);
    }

}